// extracted by mini-css-extract-plugin
export var iconsGrid = "styles-module--icons-grid--GBN43";
export var iconsGridHeader = "styles-module--icons-grid-header--1uZ2P";
export var centered = "styles-module--centered--35g4k";